import React from "react";
import PropTypes from "prop-types";

export default class ModalCampaignItem extends React.Component {
  static propTypes = {
    campaign: PropTypes.object.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onSelectCampaign: PropTypes.func.isRequired,
  };

  handleIncreaseVotes = () => {
    const { campaign, setVotes } = this.props;
    setVotes(campaign, 1);
  };

  handleDecreaseVotes = () => {
    const { campaign, setVotes } = this.props;
    setVotes(campaign, -1);
  };

  removeCampaign = () => {
    const { removeCampaign, campaign } = this.props;
    removeCampaign(campaign);
  };

  handleClick = () => {
    const { campaign, onSelectCampaign, isSelected } = this.props;
    onSelectCampaign(campaign, !isSelected);
  };

  renderCheckbox() {
    return (
      <button
        data-testid="t-ModalCa-button"
        className="voting-check"
        onClick={this.handleClick}>
        <i className="fa fa-square-o fa-fw primary-color-text" />
      </button>
    );
  }

  renderVoteOptions() {
    const { campaign, noAvailableVotes } = this.props;

    const campaignVotes = campaign.get("votes") || -1;

    return (
      <span className="picks_votes">
        <span className="vote-square">{campaign.get("votes") || 0}</span>
        <button
          data-testid="t-ModalCa-button-2"
          className="vote-button--remove"
          onClick={this.removeCampaign}>
          <i className="fa fa-times" />
        </button>
        <div className="vote-section">
          <button
            data-testid="t-ModalCa-button-3"
            className="vote-button"
            onClick={this.handleIncreaseVotes}
            disabled={noAvailableVotes}>
            <i className="fa fa-plus primary-color-text" />
          </button>
          <button
            data-testid="t-ModalCa-button-4"
            className="vote-button"
            onClick={this.handleDecreaseVotes}
            disabled={campaignVotes <= 0}>
            <i className="fa fa-minus primary-color-text" />
          </button>
        </div>
        <div className="picks_number"># of votes</div>
      </span>
    );
  }

  render() {
    const { campaign, isSelected } = this.props;

    return (
      <div className="campaign-pick">
        <span className="campaign-pick-circle circle-50">
          <img src={campaign.get("logo")} className="full-h" />
        </span>
        <h3 className="campaign-name">{campaign.get("name")}</h3>
        {isSelected ? this.renderVoteOptions() : this.renderCheckbox()}
      </div>
    );
  }
}
